import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { Platform, ModalController,  PopoverController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { register } from 'swiper/element/bundle';
import { App, URLOpenListenerEvent } from '@capacitor/app';

// #if TOUCH                                                 
//  import { UbieTouchUpdater } from '@ubie/touchupdater';
//  import { DeviceInfo } from '@ubie/device-info';                                                     
// #endif

// register Swiper
register();

import {                                              
  ActionPerformed,                                              
  PushNotificationSchema,                                              
  PushNotifications,                                              
  Token,                                              
} from '@capacitor/push-notifications';                
//import { CustomPushNotification,CustomShowPushNotificationSchema } from '@ubie/custompushnotification';                              
import { SplashScreen } from '@capacitor/splash-screen';                                              
import { StatusBar } from '@capacitor/status-bar';                                              
                                              
// ubie libs                                              
import { MessagePopupComponent, CarMessagePopupComponent, PopupCheckerService } from '@ubie/client-core';
import {                                              
  AuthService, AppInitSettingsService,                                              
  ErrorNotificationService, LogService, LogLevel,                                              
  PushNotificationToken as APIPushNotificationToken, PushNotificationsV2Service,                                              
  MqttService, IMessage,                                              
  PagesConfig, OfflinecommunicationService, QbusLocaleService                                              
} from '@ubie/core';                                              
import { Router } from '@angular/router';                                              
import { environment } from '../environments/environment';                                              
import { ThemeService } from './theme.service';                                              
                                              
import { LoginHelper } from './_helpers/loginHelper';                                              
import { SipHelper } from './_helpers/sipHelper';                                              
import { ITopic } from '@ubie/mqtt';                                              
import { LocationStrategy } from '@angular/common';      
    
// locales    
import { registerLocaleData } from '@angular/common';    
import localeNl from '@angular/common/locales/nl';    
import localeEn from '@angular/common/locales/en';    
import localeFr from '@angular/common/locales/fr';    
import moment from 'moment';    

                                              
                                              
@Component({                                              
  selector: 'app-root',                                              
  templateUrl: 'app.component.html'                                              
})                                              
export class AppComponent implements OnInit, OnDestroy {                                              
                                              
                                              
  /////////////////////////////////////////////////////////                                              
  //#region PROPERTIES                                              
  /////////////////////////////////////////////////////////                                              
                                              
  // push notification token known across the app                                              
  token: string;                                              
                                              
                                              
  mqttOffline = false;                                              
  restOffline = false;                                              
  offlineMode = false;                                              
                                              
                                               
                                              
  // When starting the app and mqtt connects, first state is disconnected, then trying                                              
  // to prevent the overlay from flashing: we skip the first 2 states                                              
  mqttConnectionCount = 0;                                              
                                              
  appInitialised = false;                                              
  pushNotificationsRegError = false;                                              
                                              
  pushNotificationChannelRequested = false;                                              
                                              

  messageSubscription: Subscription = null;
  messageChannelRequested = false;                                              
                                              
  retryCommunicationCounter = 0;                                              
                                              
  offlineTimeOutBeforeShowOffline: NodeJS.Timeout;                                              
                                              
  destroy$: Subject<boolean> = new Subject<boolean>();        

                                              
  //#endregion                                              
  /////////////////////////////////////////////////////////                                              
                                              
  constructor(                                              
    private loginHelper: LoginHelper,                                              
    private sipHelper: SipHelper,                                              
    private platform: Platform,                                              
    private translate: TranslateService,                                              
    private auth: AuthService,                                              
    private router: Router,                                              
    public modalController: ModalController,                                              
    private popoverController : PopoverController,                                              
    private mqttService: MqttService,                                              
    private ngZone: NgZone,                                              
    private appInitSettingsService: AppInitSettingsService,                                              
    private themeService: ThemeService,                                              
    private notificationService: ErrorNotificationService,                                              
    private logger: LogService,                                              
    private pushNotificationsService: PushNotificationsV2Service,                                                                                         
    private offlineCommunication: OfflinecommunicationService,                                              
   private locationStrategy: LocationStrategy,    
   private localeService: QbusLocaleService,
   private popupChecker: PopupCheckerService,
   private readonly navCtrl: NavController
  ) {    
        
    this.subscribeToLocale();    
                                              
    // set language for translations                                              
    this.translate.setDefaultLang('public_1');                                              
    this.translate.use('public_1');                                              
                                              
    // set theme                                              
    this.themeService.setTheme('qbus');                                              
                                              
    // init logging for app                                              
    this.initLogger();                                              
                                              
    // default ionic init app                                              
    this.initializeApp();                                              
  
   
                                                                        
    // subscribe to the auto login event (event is triggered when a user is logged in automatically from saved data)                                              
    this.auth.autoLoginEvent.subscribe(async () => {                                              
                                              
                                              
      this.logger.debug("auto login event");                                              
      // init mqtt and sip                                              
      if (this.appInitialised == false) {    
        
        this.logger.debug("initilizing app");     
        this.appInitialised = true;                                              
        this.loginHelper.init();                                              
                      
    
                                              
   // #if TOUCH                                              
//                this.logger.info("setting offline");
// this.offlineCommunication.SetIsUbieTouch().then(() => 
// this.offlineCommunication.start().then(() => { this.logger.info("offline checks started") })
// );
//                                                                              
//               UbieTouchUpdater.startCheckUpdate({ 'userId': this.auth.securityObject.userId, url: environment.updateUri}).then(() => {                                                             
//                   this.logger.info("check update started");                                                             
//                    });                                                                                      
//                                                                            
     // #endif      
      }                                         
                                              
                                              
      // set languag from user to use                                              
      this.translate.use('client_' + this.auth.securityObject.language.id);                                              
    }); 

      // verify if we have a saved user and set tokens if we do, this method emits an autoLogin event when a user was logged in                                              
      this.auth.getSavedUser();                                                 
  }                                              
                                              
  ngOnDestroy(): void {                                              
    this.destroy$.next(true);                                              
    this.destroy$.unsubscribe();                                              
  }                                              
                                              
                                              
  private initLogger() {                                              
    this.logger.level = LogLevel.Debug;                                              
  }                                              
                                              
                                              
  ngOnInit() {    
    this.registerLocales();                                             
                                              
    // verify mqtt connection state                                              
    this.verifyMqttConnectionState();                                              
                                              
    // verify rest connection state                                              
    this.verifyRESTConnectionState();                                              
                                              
    // Init push notifications handling                                              
    this.initPushNotifications();                                              

    this.showPopupsIfAnyOnOpenAndResume();
    // test push notifications                                              
    /*                                              
    console.log('PN test - before remove all delivered');                                              
    PushNotifications.removeAllDeliveredNotifications();                                              
    console.log('PN test - after remove all delivered');                                              
*/                                              
  }                                              
                                              
                                              
  /**                                              
   * Verify mqtt connection state                                              
   * Set variable when offline to show offline overlay                                              
   */                                              
  private verifyMqttConnectionState() {                                              
                                              
                                              
    this.mqttService                                              
      .mqttState                                              
      .pipe(takeUntil(this.destroy$))                                              
      .subscribe((online) => {                                              
        this.logger.error('verifyMqttConnectionState - received state: ' + online + ' ' + 'last mqtt state: ' + this.mqttOffline);                                              
                                              
        if (online == null ||  this.restOffline) {                                                                                         
          return;                                              
        }                                              
                                                                                       
                                                              
        if (online) {                                              
          this.retryCommunicationCounter = 0;                                              
                                              
          this.subscribeToPushNotificationChannel();                                              
          this.subscribeToMessageChannel();                                              
        }                                              
                                              
        if(online == false) {                                              
    
          this.offlineTimeOutBeforeShowOffline = setTimeout(() => { this.mqttOffline = true; },2000); 
                                               
        } else {                                              
                                              
            if(this.offlineTimeOutBeforeShowOffline) {                                            
              clearTimeout(this.offlineTimeOutBeforeShowOffline);                                           
            }                                              
                                              
          this.mqttOffline = false;                                              
        }                                              
                                              
                                                     
                                              
      });                                              
                                              
                                              
  }                                              
                                              
  /**                                              
   * Verify rest connection state                                              
   * Set variable when offline to show offline overlay                                              
   */                                              
  private verifyRESTConnectionState() {                                              
    this.notificationService                                              
      .onOfflineNotify                                              
      .pipe(takeUntil(this.destroy$))                                              
      .subscribe(offline => {                                              
        if (offline !== null) {                                              
          this.logger.debug('restOffline', offline);                                              
                                              
                                              
          if (offline === false && this.restOffline) {                                              
            this.checkLogin();                                              
          }                                              
                                              
          this.restOffline = offline;                                              
        }                                              
      });                                              
                                              
      //subscribe to offline mode chages                                              
      this.offlineCommunication.isOfflineMode.pipe(takeUntil(this.destroy$)).subscribe(offlineMode => {                                              
          //if the offline mode is not null and different of last one we change it                                              
         if(offlineMode != null && this.offlineMode != offlineMode) {                                              
            this.logger.debug('offline modus', offlineMode);                                              
                                              
            this.ngZone.run(() =>                                               
            this.offlineMode = offlineMode);                                              
                                              
         }                                              
                                              
      });                                              
                                              
  }                                              
                                              
  public getCurrentPushNotificationToken() {                                              
    return this.token;                                              
  }                                              
                                              
  public updatePushNotificationsToken() {                                              
    this.logger.debug('APP.COMPONENT - updatePushNotificationsToken', this.token);                                              
                                              
    if (this.token !== undefined) {                                              
      // update tokens in database                                               
      const ApiToken: APIPushNotificationToken = {                                              
        token: this.token                                              
      };                                              
                                              
      this.pushNotificationsService.addToken(ApiToken).subscribe(                                              
        (result) => {                                              
          this.logger.debug('result updatePushNotificationsToken', result);                                              
        },                                              
        (error) => {                                              
                                              
          this.logger.debug('failed to updatePushNotificationToken', error.message);                                              
        }                                              
      );                                              
    }                                              
  }                                              
                                              
  public deletePushNotificationsToken() {                                              
    this.logger.debug('APP.COMPONENT - deletePushNotificationsToken', this.token);                                              
    if (this.token !== undefined) {                                              
      this.pushNotificationsService.deleteToken(this.token).subscribe(                                              
        (result) => {                                              
          this.logger.debug('result deletePushNotificationsToken', result);                                              
        },                                              
        (error) => { }                                              
      );                                              
    }                                              
  }                                              
                                              
  /**                                              
   * Initiliaze the push notifications handling                                              
   */                                              
  private initPushNotifications() {                                              
    this.logger.debug('APP.COMPONENT - initPushNotifications ');                                              
                                              
    // Request permission to use push notifications                                              
    // iOS will prompt user and return if they granted permission or not                                              
    // Android will just grant without prompting                                              
    this.logger.info('request token');                                              
                                              
    PushNotifications.requestPermissions().then(result => {                                              
      if (result.receive === 'granted') {                                              
        this.logger.info('request token granted');        // Register with Apple / Google to receive push via APNS/FCM                                              
        PushNotifications.register();                                              
                                              
      } else {                                              
        // Show some error                                              
        this.logger.info('request token denied');                                              
      }                                              
    });                                              
                                              
                                              
                                                                        
                                              
    // On succcess, we should be able to receive notifications                                              
    PushNotifications.addListener('registration',                                              
      (token: Token) => {                                              
                                              
        this.logger.debug('APP.COMPONENT - initPushNotifications registration', token.value);                                              
        console.log('pn received', token);                                              
        // set token for sip helper                                              
        this.sipHelper.setPushNotificationToken(token.value);                                              
        this.token = token.value;                                              
                                              
        if (this.auth.securityObject !== null) {                                              
          this.logger.debug('subscribe');                                              
          this.updatePushNotificationsToken();                                              
          this.sipHelper.pushnotificationTokenReceived(this.token);                                              
        } else {                                              
          this.logger.debug('no subscription');                                              
        }                                              
      }                                              
    );                                              
                                              
    // Some issue with our setup and push will not work                                              
    PushNotifications.addListener('registrationError',                                              
      (error: any) => {                                              
        this.logger.debug('APP.COMPONENT - initPushNotifications registrationError', JSON.stringify(error));                                              
        this.pushNotificationsRegError = true;                                              
                                              
        this.logger.debug('subscribeToPushNotificationChannel registrationError');                                              
        this.subscribeToPushNotificationChannel();                                              
      }                                              
    );                                              
                                              
    // Show us the notification payload if the app is open on our device                                              
    PushNotifications.addListener('pushNotificationReceived',                                              
      (notification: PushNotificationSchema) => {                                              
                                              
        console.log('APP.COMPONENT - initPushNotifications pushNotificationReceived', JSON.stringify(notification));     
        
        if(notification.hasOwnProperty('data') && notification.data['carAction'] !== undefined) {
            console.log("car push notification");
            this.showCarPushNotificationPopup(notification.data);
        } else {

        this.showPushNotificationPopup(notification.title, notification.body,                                              
          notification.data?.group, notification.data?.page, notification.data?.args,                                              
          notification.hasOwnProperty('data') ? notification.data['call-id'] : undefined,
          notification.data?.goToText
          );
        }
      }                                              
    );
    
  /* CustomPushNotification.addListener('clickedPush',(notification:CustomShowPushNotificationSchema) => {
      console.log('APP.COMPONENT -  clickedPush' + JSON.stringify(notification));      
    }); */
                                              
    // Method called when tapping on a notification                                              
    PushNotifications.addListener('pushNotificationActionPerformed',                                              
      (notification: ActionPerformed) => {                                              
                                              
                                              
        console.log('APP.COMPONENT - initPushNotifications pushNotificationActionPerformed', JSON.stringify(notification));                                              
                                              
                                              
        // check if the notification object isn't undefined                                              
        if (notification.notification !== undefined) {                                              
          // check if the data isn't empty                                              
          if (notification.notification.hasOwnProperty('data')) {                                              
                                          
           if (notification.notification.data.hasOwnProperty('call-id')) {     // if we have a call id, check if the call is still active                                             
              this.sipHelper.isCallActive().then(                                              
                (data) => {                                              
                  if (!data) {                                              
                    this.showPushNotificationPopup(                                              
                      this.translate.instant(`sip_activeCall`),                                              
                      this.translate.instant(`sip_noActiveCall`), undefined, undefined, undefined, undefined);                                              
                  }                                              
                });                                              
              // this.requestCallState();                                              
            }                                              
            else {                                              
                                              
              // navigate to the page                                              
              this.navigate(notification.notification.data?.group                                              
                , notification.notification.data?.page                                              
                , notification.notification.data?.args);                                              
            }                                              
                                              
                                              
          }                                              
        }                                              
                                              
      }                                              
    );                                              
                                              
    // For android: create a default channel, notifications without a channel will use this channel                                              
    // (the channel with this ID is set as default in the Android Manifest)                                              
    PushNotifications.createChannel({id: "QbusDefault", name: "QbusControl actions", importance: 4});                                              
                                                  
    // Remove all push notifications to reset the badge count                                              
    PushNotifications.removeAllDeliveredNotifications();                                              
    // also on reopening the app from the background                                              
    this.platform.resume.subscribe(async () => PushNotifications.removeAllDeliveredNotifications());                                              
  }                                              
                                              
                                              
                                              
  /**                                              
   * Subscribe to the push notifications channel when we couldn't subscribe to the push notifications through the "normal" channel                                              
   */                                              
  private subscribeToPushNotificationChannel() {                                              
                                              
    // user must be logged in                                              
    const user = this.auth.securityObject;                                              
    if (user !== null && user !== undefined) {                                              
      if (user.isAuthenticated) {                                              
                                              
        // if we are connected to mqtt and tried making connection with pushnotifications                                              
        if (this.mqttService.mqttConnection && this.pushNotificationsRegError && !this.pushNotificationChannelRequested) {                                              
                                              
          this.pushNotificationChannelRequested = true;                                              
                                              
                                              
                                              
                                              
          let topic: ITopic = { topic: 'cloudapp/' + user.userId + '/pushnotification',ubie: 'online'};                                              
                                              
          this.mqttService.subscribe([topic]).then((x) => console.log("subscription on pushnotification"));                                              
                                              
          // to do add push notif handling                                              
                                              
        }                                              
      }                                              
    }                                              
  }                                              
                                      
  
  async showCarPushNotificationPopup(args) {
        // only show message when user it logged in                                              
        const user = this.auth.securityObject;       
        if(user !== null && user !== undefined) {
            if(user.isAuthenticated) {
               let code = args["carAction"];
               let title = args["title"];
               let body = args["body"];
               const data = args['data'];

               const showModal = await this.modalController.create({
                 component: CarMessagePopupComponent,
                 componentProps: {
                  code: code,
                  title: title,
                  body: body,
                  data
                 },
                 cssClass: 'message-modal'    
               });

               return showModal.present(); 
            }
        }
  }

                                              
  /**                                              
   * Show a popup for a push notification message                                              
   * @param title message title                                              
   * @param body message body                                              
   */                                              
  async showPushNotificationPopup(title, body, group, page, args, callId, goToText?: string) {                                              
                                              
    console.log('showPushNotificationPopup', title, body, group, page, args, callId, goToText);                                              
                                              
    // show no push notification popup when app is active and push notification contains a call id                                                  
    if (callId !== undefined) {                                              
      return;                                              
    }                                              
                                              
    // only show message when user it logged in                                              
    const user = this.auth.securityObject;                                              
    if (user !== null && user !== undefined) {                                              
      if (user.isAuthenticated) {                                              
        const showModal = await this.modalController.create({                                              
          component: MessagePopupComponent,                                              
          componentProps: {                                              
            title: title,                                              
            body: body,                                              
            group: group,                                              
            page: page,                                              
            args: args,
            goToText
          },                                              
          cssClass: 'message-modal'                                              
        });                                              
                                              
        showModal.onDidDismiss().then(x => {                                              
          if (x.data !== undefined) {                                              
            // if dismised with data then we need to navigate to the correct place                                              
            this.navigate(x.data.group, x.data.page, x.data.args);                                              
          }                                              
        });                                              
                                              
        return showModal.present();                                              
      }                                              
    }                                              
                                              
  }                                              
                                              
  /**                                              
   * Subscribe to the messages channel when we couldn't subscribe to the messages through the "normal" channel                                              
   */                                              
  private subscribeToMessageChannel() {                                              
    // user must be logged in 
    console.log('here subscribe message channel');                                             
    const user = this.auth.securityObject;                                              
    if (user !== null && user !== undefined) {                                              
      if (user.isAuthenticated) {                                              
                                              
       if(this.messageSubscription != null)
       {
          this.messageSubscription.unsubscribe();
       }
        
      this.messageSubscription =  this.mqttService.Message$                                              
        .pipe(                                              
          takeUntil(this.destroy$),                                              
          filter((message: IMessage) => { 
            return message.Id == user.userId.toString();
          })                                              
        )                                              
        .subscribe(x => {                                              
          this.ngZone.run(() => this.popupChecker.tryShowImportantMessages());                                              
        }); 

       

        // if we are connected to mqtt                                            
        if (this.mqttService.mqttConnection) {                                              
                                              
                                              
                                              
          let topic: ITopic = { topic: 'cloudapp/' + user.userId + '/message',ubie: 'online'};                                              
                                              
          this.mqttService.subscribe([topic]).then((x) => {                                              
            console.log("user message");                                              
          });                                              
                                                                                           
        }                                              
      }                                              
    }                                              
  }                                    
                                              
  /**                                              
   *  navigates to a place in the app based on group and type                                              
   * @param group the group you want to go to                                              
   * @param page  the page of the group                                              
   */                                              
  navigate(group: string, page: string, args: string) {                                              
    // navigate to the add route                                              
    const config: PagesConfig[] = this.appInitSettingsService.configuration[environment.configurations.pagesConfig];                                              
    const routes = config.filter(x => x.group === group)                                              
    // check if there is an existing route found                                              
    if (routes.length > 0) {                                              
      const pages = routes[0].pages.filter(y => y.type === page);                                              
                                              
      if (pages.length > 0) {                                              
                                              
        if (args !== undefined) {                                              
          // get the path                                              
          const path = this.parsePushNotificationPath(pages[0].pushPath, args);                                              
                                              
          // go to path                                              
          this.router.navigate([path]);                                              
        } else {                                              
                                              
          this.router.navigate([pages[0].path]);                                              
        }                                              
                                              
                                              
      }                                              
    }                                              
  }                                              
                                              
  parsePushNotificationPath(path: string, args: string): string {                                              
    const paras = args.split(';');                                              
                                              
    paras.forEach(para => {                                              
      const parts = para.split(':');                                              
      if (parts.length === 2) {                                              
        path = path.replace(parts[0], parts[1]);                                              
      }                                              
    });                                              
                                              
    return path;                                              
  }                                              
                                              
  /**                                              
   * Check if the user is logged in                                              
   */                                              
  checkLogin() {                                              
    if (!this.appInitialised) {                                              
      this.auth.getSavedUser();                                              
    }                                              
  }                                              
                                              
  /**                                              
   * Init app                                              
   */                                              
  async initializeApp() {                                              
    await this.platform.ready().then(() => {                                              
                                              
      // small timeout before hiding the splash                                              
      setTimeout(async () => {                                              
        await SplashScreen.hide();                                              
      }, 2000);                                              
                                              
      this.mqttService.startTimer();                                              
                                              
                                                  
                                               
      this.platform.backButton.subscribeWithPriority(0, async (processNextHandler) => {                                              
         this.logger.fatal("BACK BUTTON CALLED");                                              
                                              
         if(await this.modalController.getTop() != null)                                              
         {                                              
          await this.modalController.dismiss();                                              
         } else     if(await this.popoverController.getTop() != null) {                                              
          await this.popoverController.dismiss();                                              
         } else {                                              
                                                     
         this.logger.info("back button pressed dismissed pop overs and models");                                              
        processNextHandler();                                              
         }                                              
      });                                              
                                              
      this.platform.backButton.subscribeWithPriority(-1,  () => {                                              
          this.logger.info("second back button event: ");                                              
                                              
          this.locationStrategy.back();                                              
                                              
                                                        
        });                                                             
                                                             
                                                             
        // modify status bar                                                             
        StatusBar.setBackgroundColor({ color: "#333333" });                                                             
        
        this.addAppUrlOpenListener();
      });                                                             
    }                                                             
                                                               
    // async getLaunchUrl() {                                                             
    //   const ret = await Plugins.App.getLaunchUrl();                                                             
    //   if (ret && ret.url) {                                                             
    //     alert('App opened with URL: ' + ret.url);                                                             
    //   }                                                             
    //   console.log('Launch url: ', ret);                                                             
    // }        
        
    private registerLocales() {    
      registerLocaleData(localeFr);    
      registerLocaleData(localeEn);    
      registerLocaleData(localeNl);    
    }    
      
    private subscribeToLocale() {    
      this.localeService.locale$.subscribe(locale => moment.locale(locale))    
    }    
  
  private showPopupsIfAnyOnOpenAndResume() {
    const showPopupsIfLoggedIn = () => {
      if (this.auth?.securityObject?.isAuthenticated) {
        this.popupChecker.showPopups();
      }
    }

    showPopupsIfLoggedIn();

    App.addListener('resume', () => {
      showPopupsIfLoggedIn();
    })
  }

  private addAppUrlOpenListener() {
    App.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
      const {url} = event;
      console.log('App URL Open: ', url);

      if(url) {
        const appUrlScheme = 'com.ubie.cloud://';
        if(url.startsWith(appUrlScheme)) {
          console.log('Navigate in app.');
          try {
            const path = url.substring(appUrlScheme.length - 1);
            console.log('Navigate to path: ,', path);
            const isSuccess = await this.navCtrl.navigateRoot(path);
            console.log('Is navigation success: ', isSuccess);
          } catch(error) {
            console.error(error);
          }
        }
        
      } else {
        console.error("App URL Open Error: no url.")
      }
    });
  }
}